import script from "./StickyFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyFooter.vue?vue&type=script&setup=true&lang=js"

import "./StickyFooter.vue?vue&type=style&index=0&id=4176f0a8&lang=scss"

const __exports__ = script;

export default __exports__